import { AppLayout } from '@/layouts/AppLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { GlowUpPage } from '@/pages/GlowUpPage';
import { LoginPage } from '@/pages/LoginPage';
import { PointOfSalesPage } from '@/pages/PointOfSalesPage';
import { UnderwearPage } from '@/pages/UnderwearPage';
import { PromoBannerPage } from '@/pages/PromoBannerPage';
import { Paths } from '@/routes/paths';
import { PrivateRoute } from '@/routes/private-route';
import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter([
  {
    path: Paths.Dashboard,
    element: (
      <PrivateRoute>
        <AppLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: Paths.Dashboard,
        element: <DashboardPage />,
      },
      {
        path: Paths.PointOfSales,
        element: <PointOfSalesPage />,
      },
      {
        path: Paths.Underwear,
        element: <UnderwearPage />,
      },
      {
        path: Paths.GlowUp,
        element: <GlowUpPage />,
      },
      {
        path: Paths.PromoBanner,
        element: <PromoBannerPage />,
      },
    ],
  },
  {
    path: Paths.Login,
    element: <LoginPage />,
  },
]);
